import { render } from "./AddPersonDialog.vue?vue&type=template&id=9dc32372&scoped=true&ts=true"
import script from "./AddPersonDialog.vue?vue&type=script&lang=ts"
export * from "./AddPersonDialog.vue?vue&type=script&lang=ts"

import "./AddPersonDialog.vue?vue&type=style&index=0&id=9dc32372&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc32372"]])

export default __exports__